import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { SelectableItem } from './models/selectable-item';
import { SelectService } from './select.service';

const noop = () => { };
@Component({
  selector: 'ant-tree-select-item',
  template:`<span *ngIf="!haveChildren" class="ant-select-tree-switcher ant-select-tree-switcher-noop"></span>
<span *ngIf="haveChildren" class="ant-select-tree-switcher" (click)="toggleOpen($event)"
  [class.ant-select-tree-switcher-open]="isOpen"
  [class.ant-select-tree-switcher-close]="!isOpen"></span>
<span *ngIf="needCheckBox" class="ant-select-tree-checkbox"
  [class.ant-select-tree-checkbox-indeterminate]="item.checked === null"
  [class.ant-select-tree-checkbox-checked]="item.checked === true" (click)="select($event)">
    <span class="ant-select-tree-checkbox-inner"></span>
</span>
<span
    title="{{item.text}}" class="ant-select-tree-node-content-wrapper"
    [class.ant-select-tree-node-content-wrapper-open]="isOpen===true"
    [class.ant-select-tree-node-selected]="item.selected"
    (click)="toggleOpen($event)">
    <span class="ant-select-tree-title">{{item.text}}</span>
</span>
<ul class="ant-select-tree-child-tree" 
  [class.ant-select-tree-child-tree-open]="isOpen===true"
  [class.ant-select-tree-child-tree-close]="isOpen===false">
  <li *ngFor="let o of item.children | itemPipe: filter">
      <ant-tree-select-item [item]="o" (TouchedCallback)="TouchedCallback"></ant-tree-select-item>
  </li>
</ul>
`,
  styles: [`.ant-select-tree-checkbox {
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  display: inline-block;
  line-height: 1;
  position: relative;
  vertical-align: text-bottom;
}
.ant-select-tree-checkbox-input:focus + .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox:hover .ant-select-tree-checkbox-inner {
  border-color: #108ee9;
}
.ant-select-tree-checkbox-checked:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  border: 1px solid #108ee9;
  content: "";
  -webkit-animation: antCheckboxEffect 0.36s ease-in-out;
  animation: antCheckboxEffect 0.36s ease-in-out;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  visibility: hidden;
}
.ant-select-tree-checkbox-wrapper:hover .ant-select-tree-checkbox:after,
.ant-select-tree-checkbox:hover:after {
  visibility: visible;
}
.ant-select-tree-checkbox-inner {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  width: 14px;
  height: 14px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  background-color: #fff;
  -webkit-transition: all .3s;
  transition: all 0.3s;
}
.ant-select-tree-checkbox-inner:after {
  -webkit-transform: rotate(45deg) scale(0);
  -ms-transform: rotate(45deg) scale(0);
  transform: rotate(45deg) scale(0);
  position: absolute;
  left: 4px;
  top: 1px;
  display: table;
  width: 5px;
  height: 8px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  content: " ";
  -webkit-transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6);
  transition: all 0.1s cubic-bezier(0.71, -0.46, 0.88, 0.6);
}
.ant-select-tree-checkbox-input {
  position: absolute;
  left: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner:after {
  content: " ";
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  position: absolute;
  left: 2px;
  top: 5px;
  width: 8px;
  height: 1px;
}
.ant-select-tree-checkbox-indeterminate.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner:after {
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner:after {
  -webkit-transform: rotate(45deg) scale(1);
  -ms-transform: rotate(45deg) scale(1);
  transform: rotate(45deg) scale(1);
  position: absolute;
  left: 4px;
  top: 1px;
  display: table;
  width: 5px;
  height: 8px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  content: " ";
  -webkit-transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
  transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
}
.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner,
.ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner {
  background-color: #108ee9;
  border-color: #108ee9;
}
.ant-select-tree-checkbox-disabled {
  cursor: not-allowed;
}
.ant-select-tree-checkbox-disabled.ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner:after {
  -webkit-animation-name: none;
  animation-name: none;
  border-color: rgba(0, 0, 0, 0.25);
}
.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-input {
  cursor: not-allowed;
}
.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner {
  border-color: #d9d9d9!important;
  background-color: #f7f7f7;
}
.ant-select-tree-checkbox-disabled .ant-select-tree-checkbox-inner:after {
  -webkit-animation-name: none;
  animation-name: none;
  border-color: #f7f7f7;
}
.ant-select-tree-checkbox-disabled + span {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-select-tree-checkbox-wrapper {
  cursor: pointer;
  font-size: 12px;
  display: inline-block;
}
.ant-select-tree-checkbox-wrapper:not(:last-child) {
  margin-right: 8px;
}
.ant-select-tree-checkbox-group {
  font-size: 12px;
}
.ant-select-tree-checkbox-group-item {
  display: inline-block;
}
li {
  padding: 0;
  margin: 5px 0;
  list-style: none;
  white-space: nowrap;
  outline: 0;
}
.ant-select-tree li.filter-node > span {
  font-weight: 500;
}
ul {
  margin: 0;
  padding: 0 0 0 18px;
}
.ant-select-tree-node-content-wrapper {
  display: inline-block;
  padding: 3px 5px;
  border-radius: 2px;
  margin: 0;
  cursor: pointer;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.65);
  -webkit-transition: all .3s;
  transition: all .3s;
  width: calc(90%);
}
.ant-select-tree-node-content-wrapper:hover {
  background-color: #ecf6fd;
}
.ant-select-tree-node-content-wrapper.ant-select-tree-node-selected {
  background-color: #d2eafb;
}
span.ant-select-tree-checkbox {
  margin: 0 4px 0 0;
}
span.ant-select-tree-checkbox + .ant-select-tree-node-content-wrapper {
  width: calc(50%);
}
span.ant-select-tree-iconEle,
span.ant-select-tree-switcher {
  margin: 0;
  width: 24px;
  height: 24px;
  line-height: 22px;
  display: inline-block;
  vertical-align: middle;
  border: 0 none;
  cursor: pointer;
  outline: none;
  text-align: center;
}
span.ant-select-tree-icon_loading:after {
  display: inline-block;
  font-family: anticon;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\E6AE";
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
  color: #108ee9;
}
span.ant-select-tree-switcher.ant-select-tree-switcher-noop {
  cursor: auto;
}
span.ant-select-tree-switcher.ant-select-tree-switcher-open:after {
  font-size: 12px;
  font-size: 7px\9;
  -webkit-transform: scale(0.58333333) rotate(0deg);
  -ms-transform: scale(0.58333333) rotate(0deg);
  transform: scale(0.58333333) rotate(0deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  display: inline-block;
  font-family: anticon;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\E606";
  font-weight: 700;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform .3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}
span.ant-select-tree-switcher.ant-select-tree-switcher-open:after {
  -webkit-filter: none;
  filter: none;
  font-size: 12px;
}
span.ant-select-tree-switcher.ant-select-tree-switcher-close {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
}
span.ant-select-tree-switcher.ant-select-tree-switcher-close:after {
  font-size: 12px;
  font-size: 7px\9;
  -webkit-transform: scale(0.58333333) rotate(0deg);
  -ms-transform: scale(0.58333333) rotate(0deg);
  transform: scale(0.58333333) rotate(0deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  display: inline-block;
  font-family: anticon;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\E606";
  font-weight: 700;
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform .3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}
span.ant-select-tree-switcher.ant-select-tree-switcher-close:after {
  -webkit-transform: rotate(270deg) scale(0.59);
  -ms-transform: rotate(270deg) scale(0.59);
  transform: rotate(270deg) scale(0.59);
}
span.ant-select-tree-switcher.ant-select-tree-switcher-close:after {
  -webkit-filter: none;
  filter: none;
  font-size: 12px;
}
.ant-select-tree-child-tree {
  display: none;
}
.ant-select-tree-child-tree-open {
  display: block;
}
.ant-select-tree-treenode-disabled > .ant-select-tree-node-content-wrapper,
.ant-select-tree-treenode-disabled > .ant-select-tree-node-content-wrapper span,
.ant-select-tree-treenode-disabled > span,
.ant-select-tree-treenode-disabled > span.ant-select-tree-switcher {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-select-tree-treenode-disabled > .ant-select-tree-node-content-wrapper:hover {
  background: transparent;
}
.ant-select-tree-icon__close,
.ant-select-tree-icon__open {
  margin-right: 2px;
  vertical-align: top;
}
@-webkit-keyframes antCheckboxEffect {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 0.5;
  }
  to {
    -webkit-transform: scale(1.6);
    transform: scale(1.6);
    opacity: 0;
  }
}
@keyframes antCheckboxEffect {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 0.5;
  }
  to {
    -webkit-transform: scale(1.6);
    transform: scale(1.6);
    opacity: 0;
  }
}
`]
})
export class TreeSelectItemComponent {
  public get isOpen() {
    return this.item.isOpen;
  }

  @Input() public TouchedCallBack: () => void = noop;

  @Input()
  public item: SelectableItem;

  // @Output()const noop = () => { };
  // click: EventEmitter<any> = new EventEmitter<any>();

  public constructor(
    private svc: SelectService
  ) { }

  public toggleOpen($event: any): void {
    $event.stopPropagation();
    if (this.haveChildren) {
      this.item.isOpen = !this.item.isOpen;
    } else {
      this.select($event);
    }
  }

  get allowParentSelection(): boolean {
    return this.svc.Configuration.allowParentSelection;
  }

  get needCheckBox(): boolean {
    return this.svc.Configuration.isHierarchy() && this.svc.Configuration.allowMultiple;
  }

  public get haveChildren(): boolean {
    return this.item && this.item.children && this.item.children.length > 0;
  }

  public select($event: any): void {
    $event.stopPropagation();
    if (this.svc.Configuration.allowMultiple ||
      this.svc.Configuration.allowParentSelection ||
      !this.haveChildren) {
      this.svc.toggleItemSelection(this.item);
    }
    // this.TouchedCallBack();
  }

  public get filter(): string {
    return this.svc.Configuration.filter;
  }
}
